import { Icon, Tooltip } from "@mui/material";
import {
  GridActionsCellItem,
  GridAlignment,
  GridColumns,
  GridRowParams,
} from "@mui/x-data-grid";
import { IQualitaExt } from "../../../../../interfaces/lotto/attributes/models";
import { ICreateColumnsPros } from "./interfaces";

const i18_PATH = "qualita.list.columns.";

export const createColumns = ({
  t,
  onEdit,
}: ICreateColumnsPros): GridColumns<IQualitaExt> => [
  {
    field: "actions",
    type: "actions",
    align: "left" as GridAlignment,
    hideable: false,
    maxWidth: 100,
    getActions: (params: GridRowParams<IQualitaExt>) => [
      <GridActionsCellItem
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        icon={
          <Tooltip title="Modifica">
            <Icon className="fa-light fa-pen" sx={{ overflow: "visible" }} />
          </Tooltip>
        }
        label="Edit"
        onClick={() => onEdit(params.id as number)}
      />,
    ],
  },
  {
    field: "nome",
    headerName: t(`${i18_PATH}Nome`) ?? undefined,
    width: 160,
  },
  {
    field: "ext.materiale.nome",
    headerName: t(`${i18_PATH}Materiale`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.materiale?.nome,
    width: 160,
  },
  {
    field: "ext.fondo.nome",
    headerName: t(`${i18_PATH}Colore`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.fondo?.nome,
    width: 160,
  },
  {
    field: "ext.utilizzo",
    headerName: t(`${i18_PATH}Utilizzo`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.utilizzo,
    width: 160,
  },
  {
    field: "ext.finiture",
    headerName: t(`${i18_PATH}Finiture`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.finiture,
    width: 160,
  },
  {
    field: "ext.densita",
    headerName: t(`${i18_PATH}Densita`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.densita,
    width: 160,
  },
  {
    field: "ext.resistenzaCompressione",
    headerName: t(`${i18_PATH}ResistenzaCompressione`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.densita,
    width: 160,
  },
  {
    field: "ext.resistenzaFlessione",
    headerName: t(`${i18_PATH}ResistenzaFlessione`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.densita,
    width: 160,
  },
  {
    field: "ext.coefImbibizione",
    headerName: t(`${i18_PATH}CoefImbibizione`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.densita,
    width: 160,
  },
  {
    field: "ext.descrizione",
    headerName: t(`${i18_PATH}Descrizione`) ?? undefined,
    valueGetter: ({ row }) => row.ext?.descrizione,
    flex: 1,
    minWidth: 300,
  },
];
